import React from 'react';
import { Modal, Button, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';

const EventsFilter = ({ open, handleClose, handleApply }) => {
    return (
        <div>
            <Modal isOpen={open} toggle={handleClose}>
                <ModalHeader toggle={handleClose}>Filter Events</ModalHeader>
                <ModalBody>
                    <Form inline onSubmit={(e) => e.preventDefault()}>
                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4" for="exampleSelect">
                                Departments
                            </Label>
                            <Input className="col-8" id="exampleSelect" name="select" type="select">
                                <option>Center for Innovation</option>
                                <option>Industry-Accademy Collaboration</option>
                                <option>Entrepreneurship Development Club</option>
                            </Input>
                        </FormGroup>

                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4" for="exampleSelect">
                                Event{' '}
                            </Label>
                            <Input className="col-8" id="exampleSelect" name="select" type="select">
                                <option>Event 1</option>
                                <option>Event 2</option>
                                <option>Event 3</option>
                            </Input>
                        </FormGroup>
                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4" for="exampleSelect">
                                Status
                            </Label>
                            <Input className="col-8" id="exampleSelect" name="select" type="select">
                                <option>Upcoming</option>
                                <option>Ongoing</option>
                                <option>Completed</option>
                            </Input>
                        </FormGroup>
                        <FormGroup className="col-12">
                            <Label className="col-4" for="exampleSelect">
                                Category
                            </Label>
                            <Input className="col-8" id="exampleSelect" name="select" type="select">
                                <option>Aspiring Entrpreneur</option>
                                <option>Schools and Colleges</option>
                                <option>Existing Entrpreneur</option>
                                <option>Research Institutions / Universities</option>
                                <option>Industry Associations</option>
                                <option>Experts / Mentors</option>
                            </Input>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => handleApply()}>
                        Apply
                    </Button>
                    <Button color="secondary" onClick={() => handleClose()}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default EventsFilter;
